export const TypeformConfigMap = {
  PLUS_SURVEY_FOR_NON_PLUS_SUBSCRIBERS: {
    id: "mK5DfiUl",
    key: "scmp-plus-survey-for-non-plus-subscribers-typeform-is-shown",
    shouldAutoOpen: {
      desktop: false,
      mobile: false,
    },
    treatAsFinished: "onSubmit",
  },
  PLUS_SURVEY_FOR_PLUS_SUBSCRIBERS: {
    id: "UIlPK0Wm",
    key: "scmp-plus-survey-for-plus-subscribers-typeform-is-shown",
    shouldAutoOpen: {
      desktop: false,
      mobile: false,
    },
    treatAsFinished: "onSubmit",
  },
  SEARCH_RESULT: {
    // cspell:disable-next-line
    id: "nmaHYBYA",
    key: "scmp-search-result-typeform-is-shown",
    shouldAutoOpen: {
      desktop: true,
      mobile: false,
    },
    treatAsFinished: "onReady",
  },
};

export type TypeformConfigKey = keyof typeof TypeformConfigMap;
